import { useEffect, useState } from 'react';
import { useAppSelector } from 'app/hooks';
import { selectQuestionFilter } from 'features/filters/filterSlice';

const SubHeader = () => {
    const { questionDetail }: any = useAppSelector(selectQuestionFilter);

    const [barClass, setBarClass] = useState('fa-xmark')
    const [qbarClass, setQbarClass] = useState('fa-xmark')

    const toggleSidebar = () => {
        var element = document.getElementById("sidebar");
        if (element) element.classList.toggle("active");

        var questionElement = document.getElementById("question-menu");
        var sidebarEement = document.getElementById("sidebar-menu");
        if(sidebarEement && questionElement){
            if(sidebarEement.classList.contains('fa-bars')){
                sidebarEement.classList.remove("fa-bars");
                sidebarEement.classList.add("fa-xmark");

                questionElement.classList.remove("fa-filter");
                questionElement.classList.add("fa-xmark");

                var element2 = document.getElementById("question-filter");
                if (element2) element2.classList.remove("hide");

            }else{
                sidebarEement.classList.add("fa-bars");
                sidebarEement.classList.remove("fa-xmark");
            }
           
        }
        document.body.classList.toggle("sidebar-enable");
    }

    const toggleQuestionFilter = () => {
        var element = document.getElementById("question-filter");
        if (element) element.classList.toggle("hide");

        var questionElement = document.getElementById("question-menu");
        var sidebarEement = document.getElementById("sidebar-menu");
        if(sidebarEement && questionElement){
            if(questionElement.classList.contains('fa-filter')){
                questionElement.classList.remove("fa-filter");
                questionElement.classList.add("fa-xmark");

            }else{
                questionElement.classList.add("fa-filter");
                questionElement.classList.remove("fa-xmark");

                sidebarEement.classList.remove("fa-xmark");
                sidebarEement.classList.add("fa-bars");
                
                document.body.classList.remove("sidebar-enable");

                var element2 = document.getElementById("sidebar");
                if (element2) element2.classList.add("active");
            }
        }

    }

    return (
        <div id="page-topbar" style={{marginTop: "70px"}}>
            <div className="d-flex">
                <div className="first-sec">
                    <button type="button" onClick={toggleSidebar} id="sidebarCollapse" className="btn btn-info navbar-btn me-1">
                        {/* <i className="fa-solid fa-bars"></i> */}
                        <i id="sidebar-menu" className={`fa-solid ${barClass}`}></i>
                    </button>
                </div>
                <div className="second-sec">
                    <button type="button" onClick={toggleQuestionFilter} id="questionCollapse" className="btn btn-info navbar-btn me-1">
                        {/* <i className="fa-solid fa-bars"></i> */}
                        <i id="question-menu" className={`fa-solid ${qbarClass}`}></i>
                    </button>
                </div>
                {questionDetail?.chapter_name && <div className='w-100'>
                    <div className="d-flex text-white justify-center align-items-center h-100">
                        <div className="ms-3"><span className='fw-bold color-orange'>Chp: </span><span>{questionDetail.chapter_name}</span></div> 
                        <div className="ms-3"><span className='fw-bold color-orange'>Topic: </span><span>{questionDetail.topic_name}</span></div>
                    </div>
                </div>}

                <div className="d-flex justify-content-end reset-button">
                    <button className="btn btn-outline-success" onClick={()=> window.location.reload()} type="button"><i className="fa fa-refresh" /> Refresh</button>
                </div>
            </div>
        </div>
    )
};

export default SubHeader;
